/* eslint-disable camelcase,no-continue */
import {NotixApi} from "Services/api";
import { USER_COUNT_KEY } from "./user";

function responseAU(users) {
  const localUserCount = localStorage.getItem(USER_COUNT_KEY);

  if (!users?.count && users?.count !== 0) {
    if (localUserCount > 0) {
      return { count: localUserCount };
    } else {
      return null;
    }
  }

  if (users.count === 0) {
    if (localUserCount > 0) {
      return { count: localUserCount };
    } else {
      return { count: users.count };
    }
  } else {
    localStorage.setItem(USER_COUNT_KEY, users.count);
    return { count: users.count };
  }
}

class ActiveUsers {
  getActiveUsers() {
    return NotixApi.get(`/counter/active-users`).then((result) => {
      return responseAU(result);
    });
  }
}

const activeUsersInstance = new ActiveUsers();

export default activeUsersInstance;